// omggif 已移除 - 不需要 GIF 解码功能
// import {GifReader} from 'omggif';

export default (arrayBuffer, onFrame) => {
    // GIF 解码功能已移除
    console.warn('GIF decoding is not available');
    if (onFrame) {
        onFrame(0, null, 0);
    }
};
